import { Gap } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { ContinueButton } from 'page/ProfileScreen/BasicSelfiesPanel/ContinueButton'
import { Measure } from 'page/ProfileScreen/BasicSelfiesPanel/measure/Measure'
import { controller } from 'store/controller'
import { HEIGHT_MAX, HEIGHT_MIN, WEIGHT_MAX, WEIGHT_MIN } from 'store/profile/BasicForm'
import { store } from 'store/store'

export const FourthStep = observer(() => {
  const basic = store.profile.basic

  const onHeight = useLatestCallback((value: number) => {
    basic.height = value
  })

  const onWeight = useLatestCallback((value: number) => {
    basic.weight = value
  })

  const onContinue = useLatestCallback(async () => {
    controller.generateBasic()
  })

  return (
    <Vertical>
      <Vertical>
        <Typo size={24} tertiary upper center>
          {i18n('StepCount', { count: 4 })}
        </Typo>
        <Typo size={32} medium upper center>
          {i18n('FewMoreDetails')}
        </Typo>
      </Vertical>
      <Gap height={80} />
      <Vertical gap={24}>
        <Typo size={32} medium center>
          {i18n('Height')}
        </Typo>
        <Measure
          unit="unit.Cm"
          value={basic.height}
          min={HEIGHT_MIN}
          max={HEIGHT_MAX}
          onChange={onHeight}
        />
      </Vertical>
      <Gap height={120} />
      <Vertical gap={24}>
        <Typo size={32} medium center>
          {i18n('Weight')}
        </Typo>
        <Measure
          unit="unit.Kg"
          value={basic.weight}
          min={WEIGHT_MIN}
          max={WEIGHT_MAX}
          onChange={onWeight}
        />
      </Vertical>
      <Gap height={120} />
      <ContinueButton action={onContinue} />
    </Vertical>
  )
})
